import { useChatIdentity as e, useChatTransport as t } from "../transport/ChatTransportContext.mjs";
import { useMediaAdapter as n } from "../media/MediaAdapterContext.mjs";
import { useMutation as r, useQueryClient as i } from "@maat/store-hooks";
//#region src/hooks/useSendAttachmentMutation.ts
var a = 0, o = () => `optimistic-${Date.now()}-${a++}`, s = (a) => {
	let s = i(), c = e(), { api: l, keys: u } = t(), d = n();
	return r({
		mutationFn: ({ conversationId: e, ...t }) => l.sendMessageAttachments(e ?? a, t),
		onMutate: async (e) => {
			let t = e.conversationId ?? a, n = u.messages(t);
			await s.cancelQueries({ queryKey: n });
			let r = s.getQueryData(n), i = [], l = (/* @__PURE__ */ new Date()).toISOString(), f = `${c.first_name ?? ""} ${c.last_name ?? ""}`.trim() || void 0, p = [{
				id: o(),
				conversation_id: t,
				sender_id: c.id,
				body: "",
				message_type: "ATTACHMENT",
				artifact: null,
				attachments: e.files.map((t, n) => {
					let r = d.createPreviewUrl(t);
					i.push(r);
					let a = t.type.startsWith("audio/"), o = e.durations?.[n];
					return {
						id: `optimistic-att-${n}-${r}`,
						kind: t.type.startsWith("image/") ? "IMAGE" : a ? "VOICE" : "FILE",
						url: r,
						content_type: t.type,
						file_name: t.name,
						file_size: t.size,
						...a && Number.isFinite(o) ? { duration_seconds: o } : {}
					};
				}),
				created_at: l,
				sender_name: f,
				pending: !0
			}], m = e.text?.trim();
			return m && p.push({
				id: o(),
				conversation_id: t,
				sender_id: c.id,
				body: m,
				message_type: "TEXT",
				artifact: null,
				created_at: l,
				sender_name: f,
				pending: !0
			}), s.setQueryData(n, (e) => {
				if (!e || e.pages.length === 0) return e;
				let t = [...e.pages], n = t[t.length - 1];
				return t[t.length - 1] = {
					...n,
					messages: [...n.messages, ...p]
				}, {
					...e,
					pages: t
				};
			}), {
				previous: r,
				objectUrls: i,
				key: n
			};
		},
		onError: (e, t, n) => {
			n?.previous !== void 0 && s.setQueryData(n.key, n.previous), n?.objectUrls.forEach((e) => d.revokePreviewUrl(e));
		},
		onSuccess: async (e, t, n) => {
			let r = t.conversationId ?? a;
			await s.invalidateQueries({ queryKey: u.messages(r) }), u.conversations && s.invalidateQueries({ queryKey: u.conversations() }), n?.objectUrls.forEach((e) => d.revokePreviewUrl(e));
		}
	});
};
//#endregion
export { s as useSendAttachmentMutation };
